import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Text = styled.p`
  text-align: center;
  width: 80%;
  margin: auto;
  color: ${(props) => props.theme.colors.newColors.shades.title};
  margin-top: 16px;
  font-weight: 700;
`;

export const Title = styled.p`
  text-align: center;
  margin-top: 16px;
`;
